/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { createI } from '../../factoriesAny.js';
export var iDependencies = {
  ComplexDependencies,
  createI
};